import _module from "module.js";
import danteAiPopoverTemplate from "./danteAiPopover.html";
import DanteAiController from "./danteAiPopoverController";

_module.component("danteAiPopover", {
  template: danteAiPopoverTemplate,
  controllerAs: "ctrl",
  controller: DanteAiController,
});
